import React from 'react';

import { UserRoleNames } from 'core/constants';

import Chip from 'components/Chip';

import { colors } from 'theme/colors';

const UserRoleCell: React.FunctionComponent<{ role: string }> = ({ role }) => (
  <Chip
    key={role}
    label={UserRoleNames[role]}
    id={`table-tag-${role}`}
    variant="outlined"
    size="small"
    colors={{
      background: 'transparent',
      foreground: colors.text.primary,
      border: colors.grey[400],
    }}
  />
);

export default UserRoleCell;
